import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { IstRegistrationsViewModalComponent } from 'src/app/ist/ist-registrations/ist-registrations-view-modal/ist-registrations-view-modal.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { AlertsAndNotificationsServiceService } from 'src/app/services/common/alerts-and-notifications-service.service';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-notification-store',
  templateUrl: './notification-store.component.html',
  styleUrls: ['./notification-store.component.scss']
})
export class NotificationStoreComponent implements OnInit {

  gridApi: GridApi;
  columnDefs;
  operations;
  rowData;
  advanceSearch;
  selectedRow;
  logForm: UntypedFormGroup;
  collapesedOrNot: boolean = false;
  notifications:any = [];
  notificationCount:number = 0;
  alertCount:number = 0;
  alerts:any =[];

  action: Subject<any> = new Subject();
  constructor(
    private anservice:AlertsAndNotificationsServiceService,
    public modalRef: NgbActiveModal
  ) {

  }

  ngOnInit() {
    this.getUserNotifications();
  }

  getUserNotifications() {
     this.anservice.getusernotifications().subscribe(
      result => {
        this.notifications = result.filter(x => x.AnType === "NOTIFICATION");
        this.notificationCount = this.notifications.length;
        this.alerts = result.filter(x => x.AnType === "ALERT");
        this.alertCount = this.alerts.length;
      },
    );
  }

  updateNotification(orgUserNotificationId?: string) {
    if (orgUserNotificationId)
      this.anservice.updateusernotifications(orgUserNotificationId).subscribe(
        result => {
          if (result.Status) {
            this.getUserNotifications();
          }
        })
  }

  Close(){
    
    this.modalRef.close();
  }
}
